<template>
  <v-container class="candidate dashboard pt-0" style="max-width: 900px;">
    <v-card
      v-if="profile && profile.completion && profile.position && profile.position > 1"
      style="margin: auto"
    >
      <v-card-title :class="themes.candidate.light.dialogTitle">
        <div>
          <div class="headline">Profile Completion</div>
          <div class="subheading" :class="themes.candidate.light.cardSubtitle">
            Your profile is the <strong>{{ position(profile.position) }}</strong>
            most complete profile on Leaply
          </div>
        </div>
      </v-card-title>
      <v-card-text class="grey--text text--darken-2">
        The more complete your profile the better your chances of being successfully placed. Check
        your To Do list below to find ways to improve your profile.
      </v-card-text>
    </v-card>

    <ActionItems class="mt-4" style="margin: auto" />
    <Invitations class="mt-4" style="margin: auto" />
    <ApplicationShort class="mt-4" style="margin: auto" />
  </v-container>
</template>

<script>
// Components
import ActionItems from '@/components/candidate/ActionItems'
import ApplicationShort from '@/components/candidate/ApplicationShort'
import Invitations from '@/components/candidate/Invitations'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { ActionItems, ApplicationShort, Invitations },
  created() {
    this.$store.dispatch('candidate/profile/fetch')
  },
  computed: mapGetters({
    role: 'auth/role',
    user: 'auth/user',
    fullName: 'auth/fullName',
    profile: 'candidate/profile/model',
  }),
  methods: {
    position(i) {
      const j = i % 10,
        k = i % 100
      if (j == 1 && k != 11) return i + 'st'
      if (j == 2 && k != 12) return i + 'nd'
      if (j == 3 && k != 13) return i + 'rd'
      return i + 'th'
    },
  },
}
</script>
